import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from 'react-select';
import { Form, Button, Modal } from 'react-bootstrap';
import { FormValidator } from '../../helpers/form-validator';
import { Aux, Icon, Heading6, Validator, TitleIcon } from '../widgets';
import { createPerson, editPerson, getOperatorList } from '../../actions/person';
import { getUserId } from '../../helpers/session';
import "../../../assets/css/react-datetime.css";

const OperatorForm = (props) => {
    const getValidationRules = () => {
        return new FormValidator([
            {
                field: 'firstName',
                method: 'isEmpty',
                validWhen: false,
                message: 'First Name is required.'
            },
            {
                field: 'lastName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Last Name is required.'
            }
        ])
    }

    let validator = getValidationRules();

    const initialState = {
        firstName: "",
        lastName: "",
        rate: null,
        rateType: null,
        submitted: false,
        isSaving: false,
        validation: validator.valid()
    };

    const RateTypes = [
        { value: 1, label: 'Hour' },
        { value: 2, label: 'Load' },
        { value: 4, label: 'Pound' },
        { value: 5, label: 'Sack' },
        { value: 6, label: 'Ton' },
        { value: 7, label: 'Metric Ton' },
    ];

    const [state, setValue] = useState(initialState);

    const setState = (params) => { setValue({ ...state, ...params }); }

    useEffect(() => {
        if (props.isEditMode && props.info) {
            const { specification } = props.info;

            setState({
                isEditMode: true,
                firstName: props.info.first_name,
                lastName: props.info.last_name,
                rate: specification && specification.wage && specification.wage.rate ? specification.wage.rate : null,
                rateType: specification && specification.wage && specification.wage.type ? RateTypes.find(e => e.label === specification.wage.type) : null
            })
        }
    }, [])

    const handleChange = (event) => {
        const { name, value } = event.target;
        const namePattern = name === 'rate' ? (value ? Number(value.replace(/[^\w.]/g, '')) : null) : value.replace(/[^\sa-zA-z.']/g, '');
        setState({ [name]: namePattern });
    }

    const saveResource = () => {
        const validation = validator.validate(state);
        setState({ validation, submitted: true });

        if (validation.isValid) {
            const s = state;
            const cb = (isSuccess) => {
                if (isSuccess) {
                    props.onHide();
                    props.actions.getOperatorList({ farmId: props.farmId });
                }
                else setState({ isSaving: false })
            }

            setState({ isSaving: true })

            const params = {
                farm_uuid: props.farmId,
                first_name: s.firstName,
                last_name: s.lastName,
                // hourly_wage_rate: s.rate,
                specification: (s.rate && s.rateType && s.rateType.label) ? { wage: { rate: s.rate, type: s.rateType.label } } : null,
                person_role_id: 2,
                phone: "",
                city: "",
                state_id: null,
                country_id: 1,
                zipcode: "",
                created_by: getUserId()
            }

            if (!props.isEditMode) props.actions.createPerson(params, cb);
            else {
                params.person_uuid = props.info.person_uuid;
                props.actions.editPerson(params, cb);
            }
        }
    }

    const s = state;
    const validation = s.submitted ? validator.validate(state) : state.validation;

    return (<Modal show={true} onHide={props.onHide} backdrop="static" className="modal-form">
        <Form className="eg-form m-1">
            <Modal.Header closeButton>
                <Modal.Title>
                    <Heading6>
                        <TitleIcon className="fa fa-user" />
                        {!props.isEditMode ? "Add Operator" : "Edit Operator"}
                    </Heading6>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-0">
                <Aux>
                    <Form.Group>
                        <Validator validation={validation.firstName}>
                            <Form.Label htmlFor="txtFirstName">First Name <Validator.Mand /></Form.Label>
                            <Form.Control id="txtFirstName" type="text" placeholder="Enter the first name" className="form-control" autoComplete="off"
                                value={s.firstName} name="firstName" onChange={handleChange} />
                            <Validator.Text />
                        </Validator>
                    </Form.Group>
                </Aux>
                <Aux>
                    <Form.Group>
                        <Validator validation={validation.lastName}>
                            <Form.Label htmlFor="txtLastName">Last Name <Validator.Mand /></Form.Label>
                            <Form.Control id="txtLastName" type="text" placeholder="Enter the last name" className="form-control" autoComplete="off"
                                value={s.lastName} name="lastName" onChange={handleChange} />
                            <Validator.Text />
                        </Validator>
                    </Form.Group>
                </Aux>
                <Aux>
                    <Form.Group>
                        <Form.Label htmlFor="rate">Rate</Form.Label>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Form.Control
                                type="number"
                                id="rate"
                                name="rate"
                                value={s.rate}
                                onChange={handleChange}
                                style={{ width: '200px' }}
                                placeholder="Enter rate in USD($)"
                                className="form-control"
                            />

                            <div style={{ marginLeft: '10px' }}>per</div>

                            <div style={{ width: '214px', marginLeft: '10px' }}>
                                <Select
                                    id="rateType"
                                    name="rateType"
                                    className='select'
                                    value={s.rateType}
                                    onChange={e => setValue(prev => ({ ...prev, rateType: e }))}

                                    closeMenuOnSelect={true}
                                    options={RateTypes}
                                />
                            </div>
                        </div>
                    </Form.Group>
                </Aux>
            </Modal.Body>
            <Modal.Footer>
                <Button size="sm" variant="danger" className="mr-2" onClick={props.onHide}><Icon className="fa fa-times"></Icon> Cancel</Button>
                <Button size="sm" variant="primary" onClick={saveResource}><Icon className="fa fa-floppy-o"></Icon> {state.isSaving ? "Saving" : "Save"}</Button>
            </Modal.Footer>
        </Form>
    </Modal >)
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        createPerson, editPerson, getOperatorList
    }, dispatch)
});

const mapStateToProps = state => ({
    weightShortName: state.user.settings.weightShortName
});

export default connect(mapStateToProps, mapDispatchToProps)(OperatorForm);